import { Route } from "@angular/router";

import { checkIfLoggedInFn, pmoEntity } from "../../core/guards";
import { PageMode } from "../../shared/constants/enums";
import {
  createCountryPageGuards,
  createProjectPageGuards,
  createVisitsPageGuards,
  manageCountryPageGuards,
  manageMilestonesPageGuards,
  manageProjectPageGuards,
  manageVisitsPageGuards,
  viewContactsPageGuards,
  viewCountryPageGuards,
  viewMilestonesPageGuards,
  viewProjectPageGuards,
  viewVisitsPageGuards,
} from "./_guards";

const INTP_COUNTRIES_ROUTES: Route[] = [
  {
    path: "countries",
    canActivate: [pmoEntity],
    data: {
      breadcrumb: "international_projects.countries.title",
      title: "international_projects.countries.title",
    },
    children: [
      {
        path: "",
        canActivate: [...viewCountryPageGuards],
        loadComponent: () =>
          import("./intp-countries/intp-countries-list/intp-countries-list").then((e) => e.IntpCountriesListComponent),
      },
      {
        path: "create",
        canActivate: [...createCountryPageGuards],
        loadComponent: () =>
          import("./intp-countries/intp-countries-editor/intp-countries-editor").then(
            (e) => e.IntpCountriesEditorComponent
          ),
        data: {
          breadcrumb: "international_projects.countries.create",
          title: "international_projects.countries.create",
          pageMode: PageMode.create,
        },
      },
      {
        path: "edit/:id",
        canActivate: [...manageCountryPageGuards],
        loadComponent: () =>
          import("./intp-countries/intp-countries-editor/intp-countries-editor").then(
            (e) => e.IntpCountriesEditorComponent
          ),
        data: {
          breadcrumb: "international_projects.countries.edit",
          title: "international_projects.countries.edit",
          pageMode: PageMode.edit,
        },
      },
      {
        path: ":id",
        canActivate: [...viewCountryPageGuards],
        loadComponent: () =>
          import("./intp-countries/intp-countries-view/intp-countries-view").then((e) => e.IntpCountriesViewComponent),
        data: {
          breadcrumb: "international_projects.countries.single",
          title: "international_projects.countries.single",
          pageMode: PageMode.view,
        },
      },
    ],
  },
];

const INTP_VISITS_ROUTES: Route[] = [
  {
    path: "visits",
    canActivate: [pmoEntity],
    data: {
      breadcrumb: "international_projects.visits.title",
      title: "international_projects.visits.title",
    },
    children: [
      {
        path: "",
        canActivate: [...viewVisitsPageGuards],
        loadComponent: () =>
          import("./intp-country-visits/intp-country-visits-list/intp-country-visits-list").then(
            (e) => e.IntpCountryVisitsListComponent
          ),
      },
      {
        path: "create",
        canActivate: [...createVisitsPageGuards],
        loadComponent: () =>
          import("./intp-country-visits/intp-country-visits-editor/intp-country-visits-editor").then(
            (e) => e.IntpCountryVisitsEditorComponent
          ),
        data: {
          breadcrumb: "international_projects.visits.create",
          title: "international_projects.visits.create",
          pageMode: PageMode.create,
        },
      },
      {
        path: "edit/:id",
        canActivate: [...manageVisitsPageGuards],
        loadComponent: () =>
          import("./intp-country-visits/intp-country-visits-editor/intp-country-visits-editor").then(
            (e) => e.IntpCountryVisitsEditorComponent
          ),
        data: {
          breadcrumb: "international_projects.visits.edit",
          title: "international_projects.visits.edit",
          pageMode: PageMode.edit,
        },
      },
      {
        path: ":id",
        canActivate: [...viewVisitsPageGuards],
        loadComponent: () =>
          import("./intp-country-visits/intp-country-visits-editor/intp-country-visits-editor").then(
            (e) => e.IntpCountryVisitsEditorComponent
          ),
        data: {
          breadcrumb: "international_projects.visits.single",
          title: "international_projects.visits.single",
          pageMode: PageMode.view,
        },
      },
    ],
  },
];

const INTP_PROJECTS_ROUTES: Route[] = [
  {
    path: "projects",
    data: {
      breadcrumb: "international_projects.projects.title",
      title: "international_projects.projects.title",
    },
    children: [
      {
        path: "",
        canActivate: [...viewProjectPageGuards],
        loadComponent: () =>
          import("./intp-projects/intp-projects-list/intp-projects-list").then((e) => e.IntpProjectsListComponent),
      },
      {
        path: "create",
        canActivate: [...createProjectPageGuards],
        loadComponent: () =>
          import("./intp-projects/intp-projects-editor/intp-projects-editor").then(
            (e) => e.IntpProjectsEditorComponent
          ),
        data: {
          breadcrumb: "international_projects.projects.create",
          title: "international_projects.projects.create",
          pageMode: PageMode.create,
        },
      },
      {
        path: "edit/:id",
        canActivate: [...manageProjectPageGuards],
        loadComponent: () =>
          import("./intp-projects/intp-projects-editor/intp-projects-editor").then(
            (e) => e.IntpProjectsEditorComponent
          ),
        data: {
          breadcrumb: "international_projects.projects.edit",
          title: "international_projects.projects.edit",
          pageMode: PageMode.edit,
        },
      },
      {
        path: ":id",
        loadComponent: () =>
          import("./intp-projects/intp-projects-view/intp-projects-view").then((e) => e.IntpProjectsViewComponent),
        canActivate: [...viewProjectPageGuards],
        data: {
          title: "international_projects.projects.single",
          breadcrumb: "international_projects.projects.single",
        },
      },
    ],
  },
];

const INTP_MILESTONES_ROUTES: Route[] = [
  {
    path: "milestones",
    data: {
      breadcrumb: "international_projects.milestones.title",
      title: "international_projects.milestones.title",
    },
    children: [
      {
        path: "",
        canActivate: [...viewMilestonesPageGuards],
        loadComponent: () =>
          import("./intp-project-milestones/intp-project-milestones-list/intp-project-milestones-list").then(
            (e) => e.IntpProjectMilestonesListComponent
          ),
      },
      {
        path: "edit/:id",
        canActivate: [...manageMilestonesPageGuards],
        loadComponent: () =>
          import("./intp-project-milestones/intp-project-milestones-editor/intp-project-milestones-editor").then(
            (e) => e.IntpProjectMilestonesEditorComponent
          ),
        data: {
          breadcrumb: "international_projects.milestones.edit",
          title: "international_projects.milestones.edit",
          pageMode: PageMode.edit,
        },
      },
      {
        path: ":id",
        loadComponent: () =>
          import("./intp-project-milestones/intp-project-milestones-view/intp-project-milestones-view").then(
            (e) => e.IntpProjectMilestonesViewComponent
          ),
        canActivate: [...viewMilestonesPageGuards],
        data: {
          title: "international_projects.milestones.single",
          breadcrumb: "international_projects.milestones.single",
        },
      },
    ],
  },
];

const INTP_CONTACTS_ROUTES: Route[] = [
  {
    path: "contacts",
    canActivate: [...viewContactsPageGuards],
    data: {
      breadcrumb: "international_projects.contacts.title",
      title: "international_projects.contacts.title",
    },
    loadComponent: () =>
      import("./intp-contacts/intp-contacts-list/intp-contacts-list").then((e) => e.IntpContactsListComponent),
  },
];

export const INTP_ROUTES: Route[] = [
  {
    path: "international-projects",
    data: {
      breadcrumb: "international_projects.title",
    },
    canActivate: [checkIfLoggedInFn],
    children: [
      {
        path: "",
        loadComponent: () => import("../../shared/components").then((e) => e.SubmenuComponent),
      },
      ...INTP_COUNTRIES_ROUTES,
      ...INTP_PROJECTS_ROUTES,
      ...INTP_MILESTONES_ROUTES,
      ...INTP_VISITS_ROUTES,
      ...INTP_CONTACTS_ROUTES,
    ],
  },
];
